import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";

const Application = () => {
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
};
export default Application;
